import React from 'react';
import { Trash2 } from 'lucide-react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../ui/alert-dialog';
import { useLanguage } from '../../contexts/LanguageContext';

/**
 * ClearConfirmDialog - Confirmation dialog for clearing the deck
 * shadcn/ui version using AlertDialog
 */
export default function ClearConfirmDialogShadcn({
  open,
  onOpenChange,
  onConfirm,
}) {
  const { t } = useLanguage();

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t('controls.clearAll', 'Clear All Cards')}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {t('controls.confirmClearAll', 'Are you sure you want to clear all cards from your deck?')}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>
            {t('common.cancel', 'Cancel')}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={() => {
              onConfirm();
              onOpenChange(false);
            }}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            <Trash2 className="h-4 w-4 mr-2" />
            {t('controls.yesClearAll', 'Yes, Clear All')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
